export default function Text({ config }) {
  const Variant = {
    H1: (props) => <h1 {...props}></h1>,
    H2: (props) => <h2 {...props}></h2>,
    H3: (props) => <h3 {...props}></h3>,
    H4: (props) => <h4 {...props}></h4>,
    H5: (props) => <h5 {...props}></h5>,
    P: (props) => <p {...props}></p>,
  }[config.variant];

  if (!Variant) return null;

  const color = config.color
    ? "var(--color-" + config.color + ")"
    : config.variant === "P"
      ? "var(--color-gray)"
      : "var(--color-dark)";

  if (config.onClick) return (
    <a href={config.onClick}>
      <Variant
        style={{
          color,
          ...(config.style || {}),
        }}
        className="text"
        dangerouslySetInnerHTML={{ __html: config.text }}
      />
    </a>
  )

  return (
    <Variant
      style={{
        color,
        ...(config.style || {}),
      }}
      className="text"
      dangerouslySetInnerHTML={{ __html: config.text }}
    />
  );
}
